import { render, staticRenderFns } from "./DefaultFormNote.vue?vue&type=template&id=70c6fd71&"
import script from "./DefaultFormNote.vue?vue&type=script&lang=ts&"
export * from "./DefaultFormNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports